<div [ngSwitch]="getEditorType()">
    <pgs-select-editor *ngSwitchCase="'list'"
                   [cell]="cell"
                   [inputClass]="inputClass"
                   (onClick)="onClick($event)"
                   (onEdited)="onEdited($event)"
                   (onStopEditing)="onStopEditing()">
    </pgs-select-editor>

    <pgs-textarea-editor *ngSwitchCase="'textarea'"
                     [cell]="cell"
                     [inputClass]="inputClass"
                     (onClick)="onClick($event)"
                     (onEdited)="onEdited($event)"
                     (onStopEditing)="onStopEditing()">
    </pgs-textarea-editor>

    <pgs-checkbox-editor *ngSwitchCase="'checkbox'"
                     [cell]="cell"
                     [inputClass]="inputClass"
                     (onClick)="onClick($event)">
    </pgs-checkbox-editor>

    <pgs-completer-editor *ngSwitchCase="'completer'"
                      [cell]="cell">
    </pgs-completer-editor>

    <pgs-input-editor *ngSwitchDefault
                  [cell]="cell"
                  [inputClass]="inputClass"
                  (onClick)="onClick($event)"
                  (onEdited)="onEdited($event)"
                  (onStopEditing)="onStopEditing()">
    </pgs-input-editor>
</div>
